<div *ngIf="totalCount > 0" class="relative w-full h-1 bg-gray-400 rounded">
  <div class="relative h-full bg-brand-chathams-blue text-center rounded text-white" [style.width]="progressWidth"></div>
</div>
